import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { isMsalPopupCallback } from './auth/msalPopupCallback';
import './i18n';
import './styles.css';

if (!isMsalPopupCallback(window)) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
}
